<template>
  <div class='login_box'>
    <!-- <div class="ladingpage"
         v-show="dataFlag==0">
      <loding1 class="loding" />
    </div> -->
    <ul class="login_list"
        v-if="dataFlag==1">
      <li v-for="item in logList"
          :key="item.id">
        <span class="icon">
          <img :src="item.imgSrc"
               alt="">
        </span>
        <div class="payInfo">
          <p>
            <!-- <span class="phone_name">{{item.manufacturer}}</span> -->
            <span class="phone_name">{{item.model_name}}</span>
          </p>
          <p class="p2">
            <span class="phone_type">{{item.platform}}</span>
            <!-- <span>{{item.project_name}}</span><span class="name one-txt-cut">{{item.role_name}}</span>  -->
          </p>
          <p class="p3">
            <span>{{item.last_login_time}}</span>
            <span> ({{item.ip}})</span>
          </p>
        </div>
        <span class="signOut"
              @click="signOut(item)">{{$t('home.logOut')}}</span>
      </li>
    </ul>
    <div class="no_data"
         v-if="dataFlag==2">
      <img src="../../assets/images/tradeError.png"
           alt="">
      <p>{{$t('toast.noInfo')}}</p>
    </div>
  </div>
</template>

<script>
import { onlineDevices, kickOnlineDevice } from '@/api/hw'
import { getSessionStorage, getToken, removeToken } from '@/utils/stage'
import { appPostMessage } from '@/utils/communication'
export default {
  components: {
    // loding1,
  },
  data() {
    return {
      accountStorage: '',
      csrf_token: '',
      configData: '',
      phoneTypeList: '',
      phoneType: {},
      logList: [],
      dataFlag: 0,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getDeviceData()
      this.configData = JSON.parse(getSessionStorage('message'))
      this.accountStorage = JSON.parse(getSessionStorage('accountStorage'))
      const csrf_token_info = JSON.parse(getToken('csrf_token_info'))
      if (!csrf_token_info) {
        this.$router.push({ name: 'AccountVerify', query: { id: 4 } })
        // this.$toast(this.$t('toast.longTime'))
        return
      }
      const msg = Object.assign(JSON.parse(JSON.stringify(this.configData)), {
        csrf_token: csrf_token_info.csrf_token,
        access_token: this.accountStorage.access_token,
      })
      onlineDevices(msg).then((res) => {
        if (res.errcode == 509) {
          removeToken('csrf_token_info')
          this.$router.push({ name: 'AccountVerify', query: { id: 4 } })
          this.$toast(res.errmsg)
          return
        }
        if (res.data.devices.length > 0) {
          let loginArr = res.data.devices
          let deviceArr = []
          for (const i in loginArr) {
            if (loginArr[i].manufacturer) {
              deviceArr[i] = loginArr[i].manufacturer.toLocaleLowerCase()
            } else {
              deviceArr[i] = 'pc'
            }
          }
          this.getDeviceData(Array.from(new Set(deviceArr))).then((data) => {
            for (const i in loginArr) {
              if (loginArr[i].manufacturer == 'Apple') {
                for (const j in data.apple) {
                  if (data.apple[j].code_alias == loginArr[i].model) {
                    loginArr[i]['model_name'] = data.apple[j].model_name
                  }
                }
              } else {
                if (loginArr[i].manufacturer) {
                  loginArr[i]['model_name'] =
                    data[loginArr[i].manufacturer.toLocaleLowerCase()][
                      loginArr[i].model
                    ].model_name
                } else {
                  loginArr[i]['model_name'] = 'pc'
                }
              }
            }
            this.logList = JSON.parse(JSON.stringify(loginArr))
          })
          for (const i in loginArr) {
            if (loginArr[i].platform == 'pc' || loginArr[i].platform == 'web') {
              loginArr[i].platform = 'window'
              loginArr[i]['imgSrc'] = require('@/assets/images/win.png')
            } else if (loginArr[i].platform.toLocaleLowerCase() == 'ios') {
              loginArr[i]['imgSrc'] = require('@/assets/images/ios.png')
            } else {
              loginArr[i]['imgSrc'] = require('@/assets/images/and.png')
            }
          }
          this.dataFlag = 1
        } else {
          this.dataFlag = 2
        }
      })
    },
    signOut(data) {
      const csrf_token_info = JSON.parse(getToken('csrf_token_info'))
      if (!csrf_token_info) {
        this.$toast(this.$t('toast.longTime'))
        this.$router.push({ name: 'AccountVerify', query: { id: 4 } })
        return
      }
      const msg = Object.assign(JSON.parse(JSON.stringify(this.configData)), {
        csrf_token: csrf_token_info.csrf_token,
        access_token: this.accountStorage.access_token,
        kid: data.kid,
      })
      kickOnlineDevice(msg).then((res) => {
        if (res.errcode == 509) {
          removeToken('csrf_token_info')
          this.$router.push({ name: 'AccountVerify', query: { id: 4 } })
          this.$toast(res.errmsg)
          return
        }
        this.$toast(this.$t('toast.logout1'))
        if (this.accountStorage.kid == data.kid) {
          const msg = { code: 17, data: '' }
          appPostMessage(msg)
        }
        this.init()
      })
    },
    addJs(url) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = url
        script.type = 'text/javascript'
        document.body.appendChild(script)
        script.onload = () => {
          resolve()
        }
      })
    },
    async getDeviceData(arrData) {
      const arr = arrData
      let dataObj = {}
      for (const i in arr) {
        const obj = await require('../../assets/data/' + arr[i] + '.json')
        dataObj[arr[i]] = obj
      }
      return dataObj
    },
  },
}
</script>

<style  lang='less'scope>
.ladingpage {
  position: absolute;
  width: 100%;
  height: 90%;
  top: 155/75rem;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.5);
  z-index: 9999;
  .loding {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
}
.login_box {
  width: 100%;
  height: 90vh;
  padding: 0 30/75rem;
  box-sizing: border-box;
  overflow: auto;
  .login_list {
    width: 100%;
    margin-bottom: 80/75rem;
    li {
      width: 100%;
      background: #ffffff;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #cfcfcf;
      margin-top: 20px;
      position: relative;
      padding-left: 125/75rem;
      height: 140/75rem;
      padding-top: 20/75rem;
      box-sizing: border-box;
      position: relative;
      .signOut {
        display: block;
        width: 86/75rem;
        height: 49/75rem;
        background: #f2f3f4;
        border-radius: 28/75rem;
        text-align: center;
        line-height: 49/75rem;
        position: absolute;
        top: 40/75rem;
        right: 30/75rem;
      }
      .icon {
        width: 68/75rem;
        height: 68/75rem;
        // background: red;
        border-radius: 50%;
        position: absolute;
        left: 30/75rem;
        top: 37/75rem;
      }
      p {
        padding-bottom: 5/75rem;
        .phone_name {
          font-size: 22/75rem;
          color: #707070;
          margin-right: 20/75rem;
        }
        .phone_type {
          font-size: 18/75rem;
          color: #a8a8a8;
        }
      }
      .p2 {
        height: 28/75rem;
        line-height: 28/75rem;
        font-size: 22/75rem;
        color: #707070;
        span {
          display: inline-block;
          float: left;
          margin-right: 20/75rem;
        }
        .name {
          width: 120/75rem;
        }
      }
      .p3 {
        font-size: 18/75rem;
        color: #a8a8a8;
        span {
          display: inline-block;
          margin-right: 30/75rem;
        }
      }
    }
  }
  .no_data {
    width: 540/75rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    p {
      text-align: center;
      font-size: 24/75rem;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #646464;
      margin-top: 15/75rem;
    }
  }
}
</style>